'use client';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';

import { SvgIcon } from '@/components/SvgIcon';

import { IconButton } from '@/components/atoms/IconButton';

import { useCopyTooltip } from './useTooltipPosition';

import iconCopySrc from '~/icons/link-03.svg';

const sizeClassNameMap = {
  s: 'h-4 w-4',
  m: 'h-5 w-5',
  l: 'h-6 w-6',
} as const;

const ShareCopyLink = ({
  url,
  size = 'm',
}: {
  url: string;
  size?: 's' | 'm' | 'l';
}) => {
  const { texts } = useTranslation();

  const { showTooltip, handleClickCopy, buttonRef } = useCopyTooltip(url);
  return (
    <div ref={buttonRef} className='relative'>
      <IconButton
        color='secondary'
        variant='text'
        size={size}
        onClick={handleClickCopy}
        aria-label={texts.blog.copy_link}
      >
        <SvgIcon
          src={iconCopySrc}
          className={cn('text-base-black', sizeClassNameMap[size])}
        />
      </IconButton>
      {showTooltip && (
        <span className='absolute bottom-full left-1/2 -translate-x-1/2 mb-1 z-[9999] rounded bg-success-300 px-2 py-0.5 text-body-s-medium text-base-black whitespace-nowrap pointer-events-none'>
          {texts.blog.copied}
        </span>
      )}
    </div>
  );
};

export default ShareCopyLink;
